// @flow
import React from 'react';
import Author from './Author/index';
import Contacts from './Contacts/index';
import Copyright from './Copyright/index';
import Menu from './Menu/index';
import styles from './Sidebar.module.scss';
import { useSiteMetadata } from '../../hooks/index';

type Props = {
  isIndex?: boolean,
};

const Sidebar = ({ isIndex }: Props) => {
  const { author, copyright, menu } = useSiteMetadata();

  return (
    <div className={styles['sidebar']}>
      <div className={styles['sidebar__inner']}>
        <Author author={author} isIndex={isIndex} />
        <Menu menu={menu} />
        <Contacts contacts={author.contacts} />
        <Copyright copyright={copyright} />
      </div>
    </div>
  );
};

export default Sidebar;
